import { widont } from 'utils/typography';
import style from './TextBlock.module.scss';

export type BlocksTextType = {
  block_type: 'text';
  text_position: 'left' | 'right' | undefined;
  text: string;
};

export const TextBlock = ({ text, text_position }: BlocksTextType): JSX.Element => {
  const textClass = style[`text-align-${text_position}`];

  // console.log(text);
  // const t = `<h2>&ldquo;Pushing the limits of production is our expertise. In this case, gradients on cans are usually dismissed by printers due to the technical difficulty. However, with our team's in-depth understanding of can-print processes, we were able to overcome the challenge with close consultation to deliver a disruptive and ownable can design in category.&rdquo;<br /><em>Max Harkness, Creative Director, Co-Partnership</em></h2>`;
  const t = text.replaceAll('Co-Partnership', 'Co&#8209;Partnership');
  return (
    <div className={`${style.container} block-text`}>
      {/* Add h2 in the html to style a "heading" */}

      <div className={textClass} dangerouslySetInnerHTML={{ __html: widont(t) }} />
    </div>
  );
};
